@if (show) {
  <div class="pwa-banner" role="banner">
    <div class="pwa-banner__content">
      <span class="pwa-banner__text">Instale o Autolac no seu computador para acesso rápido e uso offline.</span>
      <div class="pwa-banner__actions">
        <button type="button" class="pwa-banner__btn pwa-banner__btn--install" (click)="install()">
          Instalar
        </button>
        <button type="button" class="pwa-banner__btn pwa-banner__btn--dismiss" (click)="dismiss()" aria-label="Fechar">
          Agora não
        </button>
      </div>
    </div>
  </div>
}
